module.exports = __webpack_public_path__ + "img/healthcare2.992620bd.png";